import { ApiOutlined } from "@ant-design/icons";

/** Custom RTMP destination: antd's Outlined API mark, in currentColor like the other platform marks. */
const CustomPlatform = ({ width, height }: { width?: string; height?: string }) => (
  <ApiOutlined aria-hidden style={{ fontSize: width ?? height ?? 18 }} />
);

export default CustomPlatform;
